import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  sendDirectFulfillmentRequestStart,
  sendDirectFulfillmentRequestSuccess,
  sendDirectFulfillmentRequestFailed,
} from 'redux/actions/products';
import {
  getUserProfileStart,
  getUserProfileSuccess,
  getUserProfileFailed,
  getCreditBalanceStart,
  getCreditBalanceSuccess,
  getCreditBalanceFailed,
  getCreditHistoryStart,
  getCreditHistorySuccess,
  getCreditHistoryFailed,
  getUserCreditCardsStart,
  getUserCreditCardsSuccess,
  getUserCreditCardsFailed,
  replaceUserCreditCardStart,
  replaceUserCreditCardSuccess,
  replaceUserCreditCardFailed,
  deleteUserCreditCardStart,
  deleteUserCreditCardSuccess,
  deleteUserCreditCardFailed,
  userLogoutStart,
  userLogoutSuccess,
  userLogoutFailed,
  updateCurrentUserSubscriptionPlanStart,
  updateCurrentUserSubscriptionPlanSuccess,
  updateCurrentUserSubscriptionPlanFailed,
  createCustomerAccountStart,
  createCustomerAccountSuccess,
  createCustomerAccountFailed,
  requestTaxRatesConfigurationStart,
  requestTaxRatesConfigurationSuccess,
  requestTaxRatesConfigurationFailed,
  updateUserProfileStart,
  updateUserProfileSuccess,
  updateUserProfileFailed,
  changeActiveStoreStart,
  changeActiveStoreSuccess,
  changeActiveStoreFailed,
  buySubscriptionPlanAddonStart,
  buySubscriptionPlanAddonSuccess,
  buySubscriptionPlanAddonFailed,
  getActiveStoreUsersStart,
  getActiveStoreUsersSuccess,
  getActiveStoreUsersFailed,
  userSignUpOneLoginStart,
  userSignUpOneLoginSuccess,
  userSignUpOneLoginFailed,
  refreshTokenStart,
  refreshTokenSuccess,
  refreshTokenFailed,
} from 'redux/actions/user';
import {
  uploadImageStart,
  uploadImageSuccess,
  uploadImageFailed,
  saveRequestSkuEmailDataStart,
  saveRequestSkuEmailDataSuccess,
  saveRequestSkuEmailDataFailed,
  saveRequestPromotionEmailDataStart,
  saveRequestPromotionEmailDataSuccess,
  saveRequestPromotionEmailDataFailed
} from 'redux/actions/email';
import {
  getCmsBlockByIdentifierStart,
  getCmsBlockByIdentifierSuccess,
  getCmsBlockByIdentifierFailed
} from 'redux/actions/cms_blocks';
import {
  createStripeAccountStart,
  createStripeAccountSuccess,
  createStripeAccountFailed,
  createStripeByAffiliateStart,
  createStripeByAffiliateSuccess,
  createStripeByAffiliateFailed
} from 'redux/actions/stripe';
import { parseErrorMessage, serialize } from '../helpers/api';


export const userLogoutAPI = async ({dispatch}) => {
  try {
    dispatch(userLogoutStart());
    const { data } = await api.post(`${shopManagerApi}/logout`);
    dispatch(userLogoutSuccess({data}));
  } catch (e) {
    dispatch(userLogoutFailed(e));
  }
};

export const refreshUserTokenAPI = async ({dispatch}) => {
  try {
    dispatch(refreshTokenStart());
    const {data} = await api.get(`${shopManagerApi}/onelogin/refresh`);
    dispatch(refreshTokenSuccess(data));
  } catch (e) {
    dispatch(refreshTokenFailed(e));
  }
};

export const getUserProfileAPI = async ({dispatch}) => {
  try {
    dispatch(getUserProfileStart());
    const { data } = await api.get(`${shopManagerApi}/user`);
    dispatch(getUserProfileSuccess(data));
  } catch (e) {
    dispatch(getUserProfileFailed(e));
  }
};

export const getCreditBalanceAPI = async ({dispatch}) => {
  try {
    dispatch(getCreditBalanceStart());
    const { data } = await api.get(`${shopManagerApi}/credit/balance`);
    dispatch(getCreditBalanceSuccess(data));
  } catch (e) {
    dispatch(getCreditBalanceFailed(e));
  }
};

export const getCreditHistoryAPI = async ({dispatch}) => {
  try {
    dispatch(getCreditHistoryStart());
    const { data } = await api.get(`${shopManagerApi}/credit/history?limit=500`);
    dispatch(getCreditHistorySuccess(data));
  } catch (e) {
    dispatch(getCreditHistoryFailed(e));
  }
};

export const getUserCreditCardsApi = async ({dispatch}) => {
  try {
    dispatch(getUserCreditCardsStart());
    const { data } = await api.get(`${shopManagerApi}/customer/credit-cards`);
    dispatch(getUserCreditCardsSuccess(data));
  } catch (e) {
    dispatch(getUserCreditCardsFailed(e));
  }
};


export const replaceUserCreditCardApi = async ({dispatch, ccData, masterId}) => {
  try {
    dispatch(replaceUserCreditCardStart());

    await api.post(`${shopManagerApi}/customer/credit-card`, ccData);
    await api.delete(`${shopManagerApi}/customer/credit-card`, { data: {masterId}});

    dispatch(replaceUserCreditCardSuccess());
  } catch (e) {
    dispatch(replaceUserCreditCardFailed(e));
  }
};

export const deleteUserCreditCardApi = async ({dispatch, masterId}) => {
  try {
    dispatch(deleteUserCreditCardStart());
    await api.delete(`${shopManagerApi}/customer/credit-card`, { data: {masterId}});
    dispatch(deleteUserCreditCardSuccess(masterId));
  } catch (e) {
    dispatch(deleteUserCreditCardFailed(e));
  }
};

export const saveRequestSkuEmailDataApi = async ({dispatch, emailData}) => {
  try {
    dispatch(saveRequestSkuEmailDataStart());
    const { data } = await api.post(`${shopManagerApi}/user/sku-request`, emailData);
    dispatch(saveRequestSkuEmailDataSuccess(data));
  } catch (e) {
    dispatch(saveRequestSkuEmailDataFailed());
  }
};

export const saveRequestPromotionEmailDataApi = async ({dispatch, emailData}) => {
  try {
    dispatch(saveRequestPromotionEmailDataStart());
    const { data } = await api.post(`${shopManagerApi}/user/promotion-request`, emailData);
    dispatch(saveRequestPromotionEmailDataSuccess(data));
  } catch (e) {
    dispatch(saveRequestPromotionEmailDataFailed());
  }
};

export const updateCurrentUserSubscriptionPlanApi = async ({ dispatch, userId, storeId, tierId, planId }) => {
  try {
    dispatch(updateCurrentUserSubscriptionPlanStart());
    const { data } = await api.patch(`${shopManagerApi}/subscription/tier/assign-store`, {userId, storeId, tierId, planId});
    dispatch(updateCurrentUserSubscriptionPlanSuccess(data));
  } catch (e) {
    dispatch(updateCurrentUserSubscriptionPlanFailed(e));
  }
};

export const sendDirectFulfillmentRequestApi = async ({ dispatch, userInfo}) => {
  try {
    dispatch(sendDirectFulfillmentRequestStart());
    const { data } = await api.post(`${shopManagerApi}/fulfillment/request`, userInfo);
    dispatch(sendDirectFulfillmentRequestSuccess(data));
  } catch (e) {
    dispatch(sendDirectFulfillmentRequestFailed(e));
  }
};

export const createCustomerAccountApi = async ({dispatch, user}) => {
  try {
    dispatch(createCustomerAccountStart());
    const { data } = await api.post(`${shopManagerApi}/user/create-customer`, user);
    dispatch(createCustomerAccountSuccess(data));
  } catch (e) {
    dispatch(createCustomerAccountFailed(e));
  }
};

export const requestTaxRatesConfigurationApi = async ({dispatch, requestData}) => {
  try {
    dispatch(requestTaxRatesConfigurationStart());
    await api.post(`${shopManagerApi}/user/taxrate-request`, requestData);
    dispatch(requestTaxRatesConfigurationSuccess());
  } catch (e) {
    dispatch(requestTaxRatesConfigurationFailed(e));
  }
};

export const updateUserApi = async ({dispatch, userProfile, userId}) => {
  try {
    dispatch(updateUserProfileStart());
    const { data } = await api.patch(`${shopManagerApi}/users/${userId}`, userProfile);
    dispatch(updateUserProfileSuccess(data));
  } catch (e) {
    dispatch(updateUserProfileFailed(e));
  }
};

export const changeActiveStoreApi = async ({dispatch, storeId}) => {
  try {
    dispatch(changeActiveStoreStart());
    const { data } = await api.patch(`${shopManagerApi}/users/active-store/${storeId}`);
    dispatch(changeActiveStoreSuccess(data));
  } catch (e) {
    dispatch(changeActiveStoreFailed(e));
  }
};

export const getCmsBlockByIdentifierApi = async ({dispatch, identifier}) => {
  try {
    dispatch(getCmsBlockByIdentifierStart());
    const params = {};
    identifier && (params.identifier = identifier);
    const {data} = await api.get(`${shopManagerApi}/store/cms-blocks${serialize(params)}`);
    dispatch(getCmsBlockByIdentifierSuccess(data));
  } catch (e) {
    console.log(e);
    dispatch(getCmsBlockByIdentifierFailed(e));
  }
};

export const uploadImageApi = async ({dispatch, image}) => {
  try {
    dispatch(uploadImageStart());
    const { data } = await api.post(`${shopManagerApi}/image`, image);
    dispatch(uploadImageSuccess(data));
  } catch (e) {
    dispatch(uploadImageFailed(e, image));
  }
};

export const createStripeAccountApi = async ({dispatch}) => {
  try {
    dispatch(createStripeAccountStart());
    const {data} = await api.post(`${shopManagerApi}/stripe/account`);
    dispatch(createStripeAccountSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(createStripeAccountFailed(message));
  }
};

export const ccreateStripeByAffiliateApi = async ({dispatch}) => {
  try {
    dispatch(createStripeByAffiliateStart());
    const {data} = await api.post(`${shopManagerApi}/stripe/account/affiliate`);
    dispatch(createStripeByAffiliateSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(createStripeByAffiliateFailed(message));
  }
};

export const buySubscriptionPlanAddonsApi = async ({dispatch, maxPromoSkus, maxActivePromos}) => {
  try {
    dispatch(buySubscriptionPlanAddonStart());
    const {data} = await api.post(`${shopManagerApi}/subscription/plan/addons`, { maxPromoSkus, maxActivePromos });
    dispatch(buySubscriptionPlanAddonSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(buySubscriptionPlanAddonFailed(message));
  }
};

export const getActiveStoreUsersApi = async ({dispatch, params = {} }) => {
  try {
    dispatch(getActiveStoreUsersStart());
    const query = new URLSearchParams(params).toString();
    const {data} = await api.get(`${shopManagerApi}/store-users?${query}`);
    dispatch(getActiveStoreUsersSuccess(data));
  } catch (e) {
    dispatch(getActiveStoreUsersFailed(e));
  }
};


export const userSignUpOneLoginApi = async ({dispatch, userData}) => {
  try {
    dispatch(userSignUpOneLoginStart());
    const {data} = await api.post(`${shopManagerApi}/signup`, userData);
    dispatch(userSignUpOneLoginSuccess(data));
  } catch (e) {
    dispatch(userSignUpOneLoginFailed(e));
  }
};

